<template>
  <div class="home">
    <YouthScene id="scene"/>
    <YouthArticles id="articles"/>
    <YouthInfluence id="influence"/>
    <TheComments :url="projectUrl"/>
    <TheFooter/>
  </div>
</template>

<script>
import YouthScene from '@/components/sections/YouthScene'
import YouthArticles from '@/components/sections/YouthArticles'
import YouthInfluence from '@/components/sections/YouthInfluence'
import TheComments from '@/components/TheComments'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'home',
  components: {
    YouthScene,
    YouthArticles,
    YouthInfluence,
    TheComments,
    TheFooter
  },
  inject: [ 'projectUrl' ]
}
</script>

<style lang="scss">
.home {
  position: relative;
  background: #ffffff;
}
</style>
